import { render, staticRenderFns } from "./Galeries.vue?vue&type=template&id=3390ed6b&scoped=true&"
import script from "./Galeries.vue?vue&type=script&lang=js&"
export * from "./Galeries.vue?vue&type=script&lang=js&"
import style0 from "./Galeries.vue?vue&type=style&index=0&id=3390ed6b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3390ed6b",
  null
  
)

component.options.__file = "Galeries.vue"
export default component.exports